<template>
  <div class="d-flex align-items-center">
    <auto-complete :get-data="loadClients" :result="clientSelected" :item-text="itemText"
                   placeholder="Leia klient..."/>
    <div v-if="$store.state.client" class="btn-group btn-group-sm ml-2">
      <router-link class="selected-client btn btn-warning" to="/client">
        {{$store.state.client.name}}
      </router-link>
      <a class="btn btn-warning" @click.prevent="removeClient" tabindex="0"><i class="mdi mdi-close"></i></a>
    </div>
  </div>
</template>

<script>
  import gateway from '@/services/gateway'
  import AutoComplete from './AutoComplete'

  export default {
    name: 'ClientSearch',
    components: {AutoComplete},
    methods: {
      loadClients(query) {
        return gateway.get('/clients?query=' + query).then(r => r.data)
      },
      clientSelected(item) {
        this.$store.commit('client', item)
      },
      removeClient() {
        this.$store.commit('client', null)
      },
      itemText(item) {
        return item.name
      }
    }
  };
</script>
